import React, { Fragment, useEffect, useState } from 'react'

import { GiHamburgerMenu } from 'react-icons/gi'
import { BsCreditCard2Back, BsWallet2 } from 'react-icons/bs'
import { GoNote } from 'react-icons/go'
import { IoCarSportOutline, IoBusinessOutline } from 'react-icons/io5'
import { GiChart } from 'react-icons/gi'
import { HiOutlineHomeModern, HiChevronDown, HiChevronUp } from 'react-icons/hi2'
import { MdOutlineSavings, MdOutlineBusinessCenter } from 'react-icons/md'

import '../Styles/Header.css'
import { Link } from 'react-router-dom'
import { getScrollPosition, scrollToPos } from '../Utils/general'

import logo from '../Contents/images/o/logo.png'
import { useStateValue } from '../Utils/StateProvider'

function Header() {
    const [{ site }] = useStateValue()
    const [headerClass, setHeaderClass] = useState('header desktop-header')
    const [showDrop, setShowDrop] = useState(false)
    const [yPos, setYPos] = useState(0)
    
    useEffect(() => {
        window.addEventListener('scroll', () => setYPos(getScrollPosition()))
        return () => {
            window.removeEventListener('scroll', () => setYPos(getScrollPosition()))
        }
    }, [])
    // useEffect(() => {console.log(yPos)}, [yPos])
    return (
        <header className={headerClass}>
            <nav className='main'>
                <div className="left-pt-nav">
                    <GiHamburgerMenu onClick={() => setShowDrop(!showDrop)} />
                    <button onClick={() => setShowDrop(!showDrop)}>
                        Open an account { showDrop ? <HiChevronUp /> : <HiChevronDown />}
                    </button>
                </div>
                <div className="center-pt-nav">
                    <Link to='/'>
                        <img src={logo} alt={site} height='40' />
                    </Link>
                </div>
                <div className="right-pt-nav">
                {
                    yPos > 300 && (
                        <Fragment>
                            <button onClick={() => scrollToPos(0)}>Sign In</button>
                            <span> | </span>
                            <button onClick={() => scrollToPos(0)}>EN</button>
                        </Fragment>
                    )
                }
                </div>
            </nav>
            {
                showDrop && (
                    <nav className='drop' id='drop' onClick={() => setShowDrop(false)}>
                        <ul>
                            <Link to='/reg/credit-card'>
                                <li>
                                    <BsCreditCard2Back />
                                    <span>Credit Cards</span>
                                </li>
                            </Link>
                            <Link to='/reg/checking-account'>
                                <li>
                                    <GoNote />
                                    <span>Checking Account</span>
                                </li>
                            </Link>
                            <Link to='/reg/savings-account'>
                                <li>
                                    <MdOutlineSavings />
                                    <span>Savings Account</span>
                                </li>
                            </Link>
                            <Link to='/reg/cds-tools'>
                                <li>
                                    <BsWallet2 />
                                    <span>CDs</span>
                                </li>
                            </Link>
                            <Link to='/reg/auto-loan'>
                                <li>
                                    <IoCarSportOutline />
                                    <span>Auto Loans</span>
                                </li>
                            </Link>
                            <Link to='/reg/mortgage'>
                                <li>
                                    <HiOutlineHomeModern />
                                    <span>Mortgage & Home Equity</span>
                                </li>
                            </Link>
                            <Link to='/reg/investing'>
                                <li>
                                    <GiChart />
                                    <span>Investing</span>
                                </li>
                            </Link>
                            <Link to='/reg/pro-checking-business'>
                                <li>
                                    <MdOutlineBusinessCenter />
                                    <span>Business</span>
                                </li>
                            </Link>
                            <Link to='/reg/commercial'>
                                <li>
                                    <IoBusinessOutline />
                                    <span>Commercial Banking</span>
                                </li>
                            </Link>
                        </ul>
                    </nav>
                )
            }
        </header>
    )
}

export default Header
